/**
 * @fileoverview Barrel for @quickstock/shared.
 *
 * Everything exported here must be pure: no database, no filesystem, no
 * process.env, no network. Consumers include a printed-receipt code path in the
 * till and a request handler in the cloud API, and neither can tolerate a module
 * that reaches for I/O at import time.
 */

const { getEffectiveUnitPrice, calculateAggregatedLineTotals } = require('./posCalculator');
const { formatCurrency } = require('./currencyFormatter');
const { createStoreTime } = require('./storeTime');
const {
  formatLeft,
  formatRight,
  formatCenter,
  calculateLineLength,
  getLineSeparators,
  sanitisePrintable,
} = require('./receiptLayout');
const { sanitiseString } = require('./sanitiser');

module.exports = {
  getEffectiveUnitPrice,
  calculateAggregatedLineTotals,
  formatCurrency,
  createStoreTime,
  formatLeft,
  formatRight,
  formatCenter,
  calculateLineLength,
  getLineSeparators,
  sanitisePrintable,
  sanitiseString,
};
